declare namespace $ {

	type $mol_search__hint_shm_ba_filter_section_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_shm_ba_filter_section_2 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_section['search_query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $shm_ba_filter_list__table_shm_ba_filter_section_3 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_section['table'] >
		,
		ReturnType< $shm_ba_filter_list['table'] >
	>
	type $shm_ba_filter_list__filter_shm_ba_filter_section_4 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_section['filter'] >
		,
		ReturnType< $shm_ba_filter_list['filter'] >
	>
	type $shm_ba_filter_list__search_query_shm_ba_filter_section_5 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_section['search_query'] >
		,
		ReturnType< $shm_ba_filter_list['search_query'] >
	>
	type $mol_check_expand__checked_shm_ba_filter_section_6 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_section['expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_ba_filter_section_7 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_view__sub_shm_ba_filter_section_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_section_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_section_10 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_section['tools'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_section_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_filter_section extends $mol_view {
		filter_count( ): any
		search_query( next?: string ): string
		Search( ): $mol_search
		table( ): any
		filter( next?: Record<string, any> ): Record<string, any>
		Filter( ): $shm_ba_filter_list
		section_rows( ): readonly(any)[]
		expanded( next?: boolean ): boolean
		Expand( ): $mol_check_expand
		title_content( ): readonly(any)[]
		count_label( ): string
		Count( ): $mol_view
		Label( ): $mol_view
		Tools( ): $mol_view
		title( ): string
		count( ): ReturnType< $shm_ba_filter_section['filter_count'] >
		tools( ): readonly(any)[]
		content( ): readonly(any)[]
		sub( ): ReturnType< $shm_ba_filter_section['section_rows'] >
		Title( ): $mol_view
	}
	
}

//# sourceMappingURL=section.view.tree.d.ts.map